import React from "react";

const EmptyLines = (props) => {
  const { lines = 1 } = props;
  let l = [];
  for (let i = lines; i <= lines; i++) {
    l.push(i);
  }
  return (
    <>
      {l.map((a) => {
        return (
          <>
            <div className="small-12 medium-12 column">
              <span>&nbsp;</span>
            </div>
          </>
        );
      })}
    </>
  );
};
export default EmptyLines;
